
export { Link } from "/home/runner/work/apollo/apollo/packages/core/ui/src/atoms/link/link.tsx"